import { Button, ScrollShadow } from "@heroui/react";

export interface PromptSuggestion {
  title: string;
  description: string;
}

interface PromptSuggestionsProps {
  suggestions: PromptSuggestion[];
  onSelect: (prompt: string) => void;
}

const PromptSuggestions = ({ suggestions, onSelect }: PromptSuggestionsProps) => {
  return (
    <ScrollShadow hideScrollBar className="flex flex-nowrap gap-2" orientation="horizontal">
      <div className="flex gap-2">
        {suggestions.map(({ title, description }, index) => (
          <Button
            key={index}
            className="flex h-14 flex-col items-start gap-0"
            variant="flat"
            onPress={() => onSelect(`${title} ${description}`)}
          >
            <p>{title}</p>
            <p className="text-default-500">{description}</p>
          </Button>
        ))}
      </div>
    </ScrollShadow>
  );
};

export { PromptSuggestions };
